import { Component } from '@angular/core';

@Component({
  selector: 'app-tour-popover',
  templateUrl: './tour-popover.component.html',
  styleUrls: ['./tour-popover.component.scss']
})
export class TourPopoverComponent {
  title?: string;
  content: string = '';
  showNextButton: boolean = false;
  
  onNext?: () => void;
  onClose?: () => void;

  handleNext(): void {
    if (this.onNext) {
      this.onNext();
    }
  }

  handleClose(): void {
    if (this.onClose) {
      this.onClose();
    }
  }
}
